import React, { useState, useEffect } from "react";

import {
  Navbar,
  Nav,
  NavItem,
  NavLink,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle
} from "reactstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faDatabase,
  faTachometerAlt,
  faViruses,
  faMap,
  faChartLine,
  faExternalLinkAlt
} from "@fortawesome/free-solid-svg-icons";

import bn from "../utils/bemnames";

const bem = bn.create('header');

const Header = (props) => {
  // Top level constants
  const [windowPath, setWindowPath] = useState('');
  const [windowWidth, setWindowWidth] = useState(1000);
  const activeHoverStyle = { backgroundColor: "#990000", color: "white" };
  const notActiveHoverStyle = { backgroundColor: "white", color: "#990000" };

  // Header Tabs Text Values
  const [homeText, changeHomeText] = useState(false);
  const [hueText, changeHueText] = useState(false);
  const [dashboardText, changeDashboardText] = useState(false);
  const [coronavirusText, changeCoronavirusText] = useState(false);
  const [ChartsText, changeChartsText] = useState(false);
  const [MapsText, changeMapsText] = useState(false);

  // Maps, Charts Dropdowns
  const [mapsDropdownOpen, changeMapsDropdownOpen] = useState(false);
  const [chartsDropdownOpen, changeChartsDropdownOpen] = useState(false);

  // Header Tabs Styles
  const [homeStyle, changeHomeStyle] = useState(notActiveHoverStyle);
  const [hueStyle, changeHueStyle] = useState(notActiveHoverStyle);
  const [dashboardStyle, changeDashboardStyle] = useState(notActiveHoverStyle);
  const [highwayStyle, changeHighwayStyle] = useState(notActiveHoverStyle);
  const [arterialStyle, changeArterialStyle] = useState(notActiveHoverStyle);
  const [liveStyle, changeLiveStyle] = useState(notActiveHoverStyle);
  const [sensorsStyle, changeSensorsStyle] = useState(notActiveHoverStyle);
  const [routeStyle, changeRouteStyle] = useState(notActiveHoverStyle);
  const [busEtaStyle, changeBusEtaStyle] = useState(notActiveHoverStyle);
  const [MapsStyle, changeMapsStyle] = useState(notActiveHoverStyle);
  // const [countiesStyle, changeCountiesStyle] = useState(notActiveHoverStyle);
  const [ChartsStyle, changeChartsStyle] = useState(notActiveHoverStyle);
  const [coronavirusStyle, changeCoronavirusStyle] = useState(notActiveHoverStyle);

  // User Card
  // const [isOpenUserCardPopover, changeUserCardPopover] = useState(false);

  // UseEffect to set tab styling
  useEffect(() => {
    setWindowPath(window.location.pathname);
    let activeHoverStyle = { backgroundColor: "#990000", color: "white" };

    function handleResize() {
      let { innerWidth: width } = window;
      setWindowWidth(width);
      if (width >= 800) {
        changeHomeText(true);
        changeHueText(true);
        changeDashboardText(true);
        changeMapsText(true);
        changeChartsText(true);
        changeCoronavirusText(true);
      } else {
        changeHomeText(false);
        changeHueText(false);
        changeDashboardText(false);
        changeMapsText(false);
        changeChartsText(false);
        changeCoronavirusText(false);
      }
    }

    handleResize();
    let { innerWidth: width } = window;
    if (window.location.pathname === "/app" || window.location.pathname === "/app/") {
      changeHomeStyle(activeHoverStyle);
      if (width >= 800) changeHomeText(true);
    } else if (window.location.pathname === "/app/dashboard") {
      changeDashboardStyle(activeHoverStyle);
      if (width >= 800) changeDashboardText(true);
    } else if (window.location.pathname === "/app/charts/highway" || window.location.pathname === "/app/charts/arterial") {
      changeChartsStyle(activeHoverStyle);
      if (width >= 800) changeChartsText(true);
      if (window.location.pathname === "/app/charts/highway") changeHighwayStyle(activeHoverStyle);
      if (window.location.pathname === "/app/charts/arterial") changeArterialStyle(activeHoverStyle);
    } else if (window.location.pathname === "/app/maps/traffic/live" || window.location.pathname === "/app/maps/sensors" || window.location.pathname === "/app/maps/counties") {
      changeMapsStyle(activeHoverStyle);
      if (width >= 800) changeMapsText(true);
      if (window.location.pathname === "/app/maps/traffic/live") changeLiveStyle(activeHoverStyle);
      if (window.location.pathname === "/app/maps/sensors") changeSensorsStyle(activeHoverStyle);
      // if (window.location.pathname === "/app/maps/counties") changeCountiesStyle(activeHoverStyle);
    } else if (window.location.pathname === "/app/coronavirus") {
      changeCoronavirusStyle(activeHoverStyle);
      if (width >= 800) changeCoronavirusText(true);
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Navbar style={{ height: "5vh" }} light expand className={bem.b('bg-white') + ' p-0'}>
      <Nav pills>
        <NavItem className="m-1">
          <div onMouseEnter={() => {
            changeHomeStyle(activeHoverStyle);
            changeHomeText(true);
          }}
            onMouseLeave={() => {
              (windowPath !== "/app" || windowPath !== "/app/") && changeHomeStyle(notActiveHoverStyle);
              (windowWidth < 800) && changeHomeText(false)
            }}>
            <NavLink style={homeStyle} href="/app" active>
              <div>
                <FontAwesomeIcon icon={faHome} size="sm" />{homeText ? ' ADMS' : ''}
              </div>
            </NavLink>
          </div>
        </NavItem>

        <NavItem className="m-1">
          <div onMouseEnter={() => {
            changeDashboardStyle(activeHoverStyle);
            changeDashboardText(true)
          }} onMouseLeave={() => {
            windowPath !== "/app/dashboard" && changeDashboardStyle(notActiveHoverStyle);
            (windowWidth < 800) && changeDashboardText(false)
          }}>
            <NavLink style={dashboardStyle} href="/app/dashboard" active>
              <div><FontAwesomeIcon icon={faTachometerAlt} size="sm" />{dashboardText ? ' Dashboard' : ''}</div>
            </NavLink>
          </div>
        </NavItem>
        <Dropdown nav isOpen={chartsDropdownOpen}
          toggle={() => changeChartsDropdownOpen(chartsDropdownOpen ? chartsDropdownOpen : !chartsDropdownOpen)}
          onMouseEnter={() => {
            changeChartsStyle(activeHoverStyle);
            changeChartsDropdownOpen(true);
            changeChartsText(true);
          }} onMouseLeave={() => {
            changeChartsStyle(windowPath !== "/app/charts/highway" && windowPath !== "/app/charts/arterial" ? notActiveHoverStyle : activeHoverStyle);
            changeChartsDropdownOpen(false);
            (windowWidth < 800) && changeChartsText(false)
          }}>
          <div className="m-1">
            <DropdownToggle onClick={() => {
            }} className="text-white m-0 p-0 border-0 bg-white" style={{ boxShadow: "none" }}>
              <NavLink style={ChartsStyle} active>
                <div><FontAwesomeIcon icon={faChartLine} size="sm" />{ChartsText ? ' Charts' : ''}</div>
              </NavLink>
            </DropdownToggle>
          </div>
          <DropdownMenu className="p-0" style={{ minWidth: "unset" }}>
            <NavLink className="p-1" onMouseEnter={() => changeHighwayStyle(activeHoverStyle)}
              onMouseLeave={() => changeHighwayStyle(windowPath !== "/app/charts/highway" ? notActiveHoverStyle : activeHoverStyle)}
              style={highwayStyle} href="/app/charts/highway"><DropdownItem className="p-2"
                style={{ ...highwayStyle }}><FontAwesomeIcon
                  icon={faChartLine} size="sm" /> Highway</DropdownItem></NavLink>
            <DropdownItem className="m-0" divider />
            <NavLink className="p-1" onMouseEnter={() => changeArterialStyle(activeHoverStyle)}
              onMouseLeave={() => changeArterialStyle(windowPath !== "/app/charts/arterial" ? notActiveHoverStyle : activeHoverStyle)}
              style={arterialStyle} href="/app/charts/arterial"><DropdownItem className="p-2"
                style={{ ...arterialStyle }}><FontAwesomeIcon
                  icon={faChartLine} size="sm" /> Arterial</DropdownItem></NavLink>
          </DropdownMenu>
        </Dropdown>
        <Dropdown nav isOpen={mapsDropdownOpen}
          toggle={() => changeMapsDropdownOpen(mapsDropdownOpen ? mapsDropdownOpen : !mapsDropdownOpen)}
          onMouseEnter={() => {
            changeMapsStyle(activeHoverStyle);
            changeMapsText(true);
            changeMapsDropdownOpen(true);
          }} onMouseLeave={() => {
            changeMapsStyle(windowPath !== "/app/maps/traffic/live" && windowPath !== "/app/maps/sensors" && windowPath !== "/app/maps/counties" ? notActiveHoverStyle : activeHoverStyle);
            changeMapsDropdownOpen(false);
            (windowWidth < 800) && changeMapsText(false)
          }}>
          <div className="m-1">
            <DropdownToggle onClick={() => {
            }} className="text-white m-0 p-0 border-0 bg-white" style={{ boxShadow: "none" }}>
              <NavLink style={MapsStyle} active>
                <div><FontAwesomeIcon icon={faMap} size="sm" />{MapsText ? ' Maps' : ''}</div>
              </NavLink>
            </DropdownToggle>
          </div>
          <DropdownMenu className="p-0" style={{ minWidth: "unset" }}>
            <NavLink className="p-1" onMouseEnter={() => changeLiveStyle(activeHoverStyle)}
              onMouseLeave={() => changeLiveStyle(windowPath !== "/app/maps/traffic/live" ? notActiveHoverStyle : activeHoverStyle)}
              style={liveStyle} href="/app/maps/traffic/live"><DropdownItem className="p-2"
                style={{ ...liveStyle }}><FontAwesomeIcon
                  icon={faMap} size="sm" /> Traffic</DropdownItem></NavLink>
            <DropdownItem className="m-0" divider />
            <NavLink className="p-1" onMouseEnter={() => changeSensorsStyle(activeHoverStyle)}
              onMouseLeave={() => changeSensorsStyle(windowPath !== "/app/maps/sensors" ? notActiveHoverStyle : activeHoverStyle)}
              style={sensorsStyle} href="/app/maps/sensors">
              <DropdownItem className="p-2"
                style={{ ...sensorsStyle }}><FontAwesomeIcon
                  icon={faMap} size="sm" /> Sensors</DropdownItem>
            </NavLink>
            {/*<DropdownItem className="m-0" divider />*/}
            {/*<NavLink className="p-1" style={countiesStyle}*/}
            {/*  onMouseEnter={() => changeCountiesStyle(activeHoverStyle)}*/}
            {/*  onMouseLeave={() => changeCountiesStyle(notActiveHoverStyle)}*/}
            {/*  href="/app/maps/counties">*/}
            {/*  <DropdownItem className="p-2" style={{ ...countiesStyle }}>*/}
            {/*    <FontAwesomeIcon icon={faMap} size="sm" /> Counties*/}
            {/*  </DropdownItem>*/}
            {/*</NavLink>*/}
            <DropdownItem className="m-0" divider />
            <NavLink className="p-1" style={routeStyle}
                     onMouseEnter={() => changeRouteStyle(activeHoverStyle)}
                     onMouseLeave={() => changeRouteStyle(notActiveHoverStyle)}
                     onClick={() => window.open("/app/route")}>
              <DropdownItem className="p-2" style={{ ...routeStyle }}>
                <FontAwesomeIcon icon={faMap} size="sm" /> Predictive Routing &nbsp;
                <FontAwesomeIcon icon={faExternalLinkAlt} size={"sm"} color={"#727272"} />
              </DropdownItem>
            </NavLink>
            <DropdownItem className="m-0" divider />
            <NavLink className="p-1" style={busEtaStyle}
                     onMouseEnter={() => changeBusEtaStyle(activeHoverStyle)}
                     onMouseLeave={() => changeBusEtaStyle(notActiveHoverStyle)}
                     onClick={() => window.open("https://adms.usc.edu/caltrans")}>
              <DropdownItem className="p-2" style={{ ...busEtaStyle }}>
                <FontAwesomeIcon icon={faMap} size="sm" /> Bus ETA &nbsp;
                <FontAwesomeIcon icon={faExternalLinkAlt} size={"sm"} color={"#727272"} />
              </DropdownItem>
            </NavLink>
          </DropdownMenu>
        </Dropdown>

        <NavItem className="m-1">
          <div onMouseEnter={() => {
            changeCoronavirusStyle(activeHoverStyle);
            changeCoronavirusText(true)
          }} onMouseLeave={() => {
            windowPath !== "/app/coronavirus" && changeCoronavirusStyle(notActiveHoverStyle);
            (windowWidth < 800) && changeCoronavirusText(false)
          }}>
            <NavLink style={coronavirusStyle} href="/app/coronavirus" active>
              <div><FontAwesomeIcon icon={faViruses} size="sm" />{coronavirusText ? ' Coronavirus' : ''}</div>
            </NavLink>
          </div>
        </NavItem>
      </Nav>

      <Nav navbar className={bem.e('nav-right')} pills>
        <NavItem className="m-1">
          <div onMouseEnter={() => {
            changeHueStyle(activeHoverStyle);
            changeHueText(true);
          }} onMouseLeave={() => {
            changeHueStyle(notActiveHoverStyle);
            (windowWidth < 800) && changeHueText(false)
          }}>
            <NavLink style={hueStyle} onClick={() => window.open('https://admshue.usc.edu')} active>
              <div><FontAwesomeIcon icon={faDatabase} size="sm" />{hueText ? ' ADMS Hue' : ''}</div>
            </NavLink>
          </div>
        </NavItem>
      </Nav>
      {/* User Icon
            <Nav navbar className={bem.e('nav-right')}>
                <NavItem>
                    <NavLink id="UserPopover">
                        <Avatar
                            onClick={() => changeUserCardPopover(!isOpenUserCardPopover)}
                            className="can-click"
                            size={25}
                        />
                    </NavLink>
                    <Popover
                        placement="bottom-end"
                        isOpen={isOpenUserCardPopover}
                        toggle={() => changeUserCardPopover(!isOpenUserCardPopover)}
                        target="UserPopover"
                        className="p-0 border-0"
                        style={{ minWidth: 250 }}>
                        <PopoverBody className="p-0 border-light">
                            <UserCard
                                title="Tommy"
                                subtitle="tommy.trojan@usc.edu"
                                text=""
                                className="border-light">
                                <ListGroup flush>
                                    <ListGroupItem tag="button" action className="border-light">
                                        <FontAwesomeIcon icon={faUser} /> Profile
                                        </ListGroupItem>
                                    <ListGroupItem tag="button" action className="border-light">
                                        <FontAwesomeIcon icon={faCogs} /> Settings
                                        </ListGroupItem>
                                    <ListGroupItem tag="button" action className="border-light">
                                        <FontAwesomeIcon icon={faQuestionCircle} /> Help
                                        </ListGroupItem>
                                    <ListGroupItem tag="button" action className="border-light">
                                        <FontAwesomeIcon icon={faSignOutAlt} /> Signout
                                        </ListGroupItem>
                                </ListGroup>
                            </UserCard>
                        </PopoverBody>
                    </Popover>
                </NavItem>
            </Nav>*/}
    </Navbar>
  );
}

export default Header;